<template>
  <v-container class="uploadContainer" grid-list-xl quoteSettingsContainer style="overflow: hidden !important;">
    <v-form>
      <v-layout row wrap>
        <v-flex lg12 v-if="showMeta == true">
          <h2 >Delivery signed and accepted by:</h2>
        </v-flex>
        <v-flex lg1 v-if="showMeta == true">
          <label class="blackLabel">Name:</label>
        </v-flex>
        <v-flex lg2 v-if="showMeta == true">
          <v-text-field label="Name" v-model="metaData.name" solo></v-text-field>
        </v-flex>
        <v-flex lg9 v-if="showMeta == true">
        </v-flex>
        <v-flex lg1 v-if="showMeta == true">
          <label class="blackLabel">Surname:</label>
        </v-flex>
        <v-flex lg2 v-if="showMeta == true">
          <v-text-field label="Surname" v-model="metaData.surname" solo></v-text-field>
        </v-flex>
        <v-flex lg9 v-if="showMeta == true">
        </v-flex>
        <v-flex lg1 v-if="showMeta == true">
          <label class="blackLabel">ID No:</label>
        </v-flex>
        <v-flex lg2 v-if="showMeta == true">
          <v-text-field label="ID No" v-model="metaData.idNo" solo></v-text-field>
        </v-flex>
        <v-flex lg9 v-if="showMeta == true">
        </v-flex>
        <v-flex lg1 v-if="showMeta == true">
          <label class="blackLabel">Location:</label>
        </v-flex>
        <v-flex lg2 v-if="showMeta == true">
          <v-text-field label="Location" v-model="metaData.location" solo></v-text-field>
        </v-flex>
        <v-flex lg9 v-if="showMeta == true">
        </v-flex>
        <v-flex lg1 v-if="showMeta == true">
          <label class="blackLabel">Employer:</label>
        </v-flex>
        <v-flex lg2 v-if="showMeta == true">
          <v-text-field label="Employer" v-model="metaData.employer" solo></v-text-field>
        </v-flex>
        <v-flex lg9 v-if="showMeta == true">
        </v-flex>
        <v-flex lg9 v-if="showMeta == true">
          <v-btn color="info" style="float: left;" @click.prevent="fncSaveMeta">Update</v-btn>
          <v-btn class="text-xs-right cancelButton" style="float: left;" @click.stop="fncCancelMeta">Update Later</v-btn>
        </v-flex>
        <v-tabs slider-color="grey" v-model="selectedIndex" v-if=" !showMeta && globalModalParams.vendor != 0 && (globalModalParams.vendor != undefined || globalModalParams.vendor != 'undefined' )">
          <v-tab class="tab" :key="tabkeys[0]" ripple>Quote Attachments</v-tab>
          <v-tab class="tab" :key="tabkeys[1]" ripple>Purchase Order Attachments</v-tab>
          <v-tab-item class="pl-4 pr-4 pt-4 pb-4" :key="1">
            <div style="float: left; width: 50%; margin-top: 10px;">
              <p>Please select a file to upload and click the "Upload" button to continue</p>
              <p class="smalltext">Maximum file size allowed: {{ objAuthorize.max_upload_size }}MB</p>
              <p class="smalltext">File types supported: {{ objAuthorize.allowed_file_types }}</p>
              <v-checkbox class="normalCheckbox" v-if="attachmentCategories.length > 1" v-model="viewAllDocs" @change="fncViewAllDocuments()" label="View All Documents"></v-checkbox>
            </div>
            <div style="float: left; width: 50%; margin-top: 10px;">
              <div v-if="attachmentCategories.length > 1" >
                <!--<p>Please select the attachment category</p>
                <v-select v-if="uploadError == false" :items="attachmentCategories" label="Attachment Category" @input="fncFilterAttachments()" class="dropdown" v-model="selectedAttachmentCategory" item-value="id" item-text="name" solo single-line></v-select>
                <v-select v-else :items="attachmentCategories" label="Attachment Category" @input="fncFilterAttachments()" class="dropdown" style="border: 1px solid red !important;" v-model="selectedAttachmentCategory" item-value="id" item-text="name" solo single-line></v-select>-->
                <small class="uploadError" v-if="uploadError == true">Please select a category, and then reupload the file.</small>
<!--                <small>Please note changing the above status will filter the below list and categorize the below file</small>-->
              </div>

              <input type="file" id="quoteFile" class="fileUpload" style="padding-top: 30px !important;padding-bottom: 30px !important;" @change="fncSetImageObj">
              <div class="fileHolder" style="height: 85px !important;">
                <p>Drag & Drop / Click to Add Files</p>
                <small>{{ fileName }}</small>
              </div>
            </div>
<!--            <small style="margin-top: 20px;border-top: 1px solid #ECECEC;width: 100%; float: left;"  class="pt-4 pb-4" v-if="quoteSettings.attachments.length == 0 && busyUploading== 0"><strong>No attachments has been uploaded to this quote</strong></small>-->
            <p v-if="quoteSettings.attachments.length != 0 && busyUploading== 0" style="width: 50% !important;">Filter attachment categories</p>
            <v-select style="width: 50% !important;" v-if="quoteSettings.attachments.length != 0 && busyUploading == 0" :items="attachmentCategories" label="Attachment Category" @input="fncFilterAttachments()" class="dropdown" v-model="selectedAttachmentCategory" item-value="id" item-text="name" solo single-line></v-select>
            <v-data-table :headers="headers" :items="filteredAttachments" v-if="quoteSettings.attachments.length != 0 && busyUploading== 0" class="elevation-1 attachmentList" hide-actions>
              <!--<v-data-table style="margin-top: 20px;float: left; clear: both;" :headers="headers" :items="quoteSettings.attachments" v-if="quoteSettings.attachments.length != 0" class="elevation-1" hide-actions>-->
              <template slot="items" slot-scope="props">
                <td width="25%"><a @click.prevent="fncOpenFile(props.item.path)">{{ props.item.original_filename }}</a></td>
                <td width="20%"><a @click.prevent="fncOpenFile(props.item.path)">{{ fncGetLocalizedDateFromUTC(props.item.created_timestamp ) }}</a></td>
                <td width="25%" v-if="attachmentCategories.length > 1"><v-select :items="attachmentCategories" label="Attachment Category" @input="fncSaveAttachmentCategory( props.item )" class="dropdown" v-model="props.item.category" item-value="id" item-text="name" solo single-line></v-select></td>
                <td width="25%" v-else>N/A</td>
                <td width="20%">{{ props.item.fullname }}</td>
                <td width="10%"><a @click.prevent="fncRemoveImage(props.item.id)"><i class="material-icons">delete</i></a></td>
              </template>
            </v-data-table>
            <p v-if="busyUploading == 1" class="waitingUpload"><strong>Uploading... Please wait...</strong></p>
            <!--<p class="smalltext"><b>Maximum file size allowed:</b> {{ objAuthorize.max_upload_size }}MB</p>
            <p class="smalltext"><b>File types supported:</b> {{ objAuthorize.allowed_file_types }}</p><br><br>
            <input type="file" id="quoteFile" class="fileUpload" @change="fncSetImageObj">
            <div class="fileHolder">
              <p>Drag & Drop / Click to Add Files</p>
              <small>{{ fileName }}</small>
            </div>
            <br />
            <small class="pt-4 pb-4" v-if="quoteSettings.attachments.length == 0">No attachments have been uploaded to this quote</small>
            <v-data-table :headers="headers" :items="quoteSettings.attachments" v-if="quoteSettings.attachments.length != 0" class="elevation-1" hide-actions>
              <template slot="items" slot-scope="props">
                <td width="40%" class="text-xs-right"><a @click.prevent="fncOpenFile(props.item.path)">{{ props.item.original_filename }}</a></td>
                <td width="25%" class="text-xs-right"><a @click.prevent="fncOpenFile(props.item.path)">{{ props.item.created_timestamp }}</a></td>
                <td width="25%" class="text-xs-right"><a @click.prevent="fncOpenFile(props.item.path)">{{ props.item.created_timestamp }}</a></td>
                <td width="10%" class="text-xs-right"><a @click.prevent="fncRemoveImage(props.item.id)"><i class="material-icons">delete</i></a></td>
              </template>
            </v-data-table>-->
          </v-tab-item>
          <v-tab-item class="pl-4 pr-4 pt-4 pb-4" :key="2">
            <div style="display: inline-block; width: 50%; margin-top: 10px;">
              <p style="font-weight: bold;">These are attachments that were loaded by the Vendor on the Vendor portal.</p>
              <p>Please select a file to upload and click the "Upload" button to continue</p>
              <p class="smalltext">Maximum file size allowed: {{ objAuthorize.max_upload_size }}MB</p>
              <p class="smalltext">File types supported: {{ objAuthorize.allowed_file_types }}</p>
<!--              <v-checkbox class="normalCheckbox" v-if="attachmentCategories.length > 1" v-model="viewAllDocs" @change="fncViewAllDocuments()" label="View All Documents"></v-checkbox>-->
            </div>
            <div style="display:inline-block; width: 45%; margin-top: 10px;">
              <div v-if="attachmentCategories.length > 1" >
                <!--<p>Please select the attachment category</p>
                <v-select v-if="uploadError == false" :items="attachmentCategories" label="Attachment Category" @input="fncFilterAttachments()" class="dropdown" v-model="selectedAttachmentCategory" item-value="id" item-text="name" solo single-line></v-select>
                <v-select v-else :items="attachmentCategories" label="Attachment Category" @input="fncFilterAttachments()" class="dropdown" style="border: 1px solid red !important;" v-model="selectedAttachmentCategory" item-value="id" item-text="name" solo single-line></v-select>-->
                <small class="uploadError" v-if="uploadError == true">Please select a category, and then reupload the file.</small>
<!--                <small>Please note changing the above status will filter the below list and categorize the below file</small>-->
              </div>
              <input type="file" id="quoteFile" class="fileUpload" style="padding-top: 30px !important;padding-bottom: 30px !important;" @change="fncSetSoImageObj">
              <div class="fileHolder" style="height: 85px !important;">
                <p>Drag & Drop / Click to Add Files</p>
                <small>{{ fileName }}</small>
              </div>
            </div>
            <v-data-table :headers="soHeaders" :items="quoteSettings.details.soAttachments" class="elevation-1 attachmentList" hide-actions>
              <template slot="items" slot-scope="props">
                <tr>
                <td width="25%">
                  <a @click.prevent="fncOpenFile(props.item.path)">{{ props.item.original_filename }}</a>
                  <div style="margin-top: 10px; text-indent: 5px;"  v-if="fncCanUpdatePod(props.item) && props.item.meta_data != null">
                    <b>Delivery signed and Received by:</b>
                    <div><b>Name:</b> {{ JSON.parse(props.item.meta_data).name }} {{ JSON.parse(props.item.meta_data).surname }}</div>
                    <div><b>ID No:</b> {{ JSON.parse(props.item.meta_data).idNo }}</div>
                    <div><b>Location:</b> {{ JSON.parse(props.item.meta_data).location }}</div>
                    <div><b>Employer:</b> {{ JSON.parse(props.item.meta_data).employer }}</div>
                  </div>
                </td>
                <td width="15%"><a @click.prevent="fncOpenFile(props.item.path)">{{ fncGetLocalizedDateFromUTC( props.item.created_timestamp ) }}</a></td>
                <td width="20%" v-if="attachmentCategories.length > 1" class="text-xs-left">
                  <v-select :items="attachmentCategories" label="Attachment Category" @input="fncSaveAttachmentCategory( props.item )" class="dropdown" v-model="props.item.category" item-value="id" item-text="name" solo single-line></v-select>
                </td>
                <td width="30%" class="text-xs-right">
                  <div style="margin-top: 10px;font-size: 12px !important; display: flex; justify-content: space-between;">
                    <v-btn color="info" v-if="fncCanUpdatePod(props.item)" :style="getStyle()" @click="fncShowMeta(props.item.id, props.item.meta_data)">UPDATE ORDER RECIPIENT DETAILS</v-btn>
                    <v-btn color="info" v-if="fncCanUpdatePod(props.item) && fncCheckStatus(props.index) && quoteSettings.details.status !== 'POD Uploaded'" style="width: 48%;" @click="fncUpdatePodStatus(props.item.id, props.index)" v-html="fncCheckPodStatus()"></v-btn>
                  </div>
                </td>
                <td width="5%" class="text-xs-left"><a @click.prevent="fncRemoveFile(props.item)"><i class="material-icons">delete</i></a></td>
                  <td width="5%">
                    <v-checkbox @change="fncMarkPaid(props.item)" v-model="props.item.is_paid"></v-checkbox>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-tab-item>
        </v-tabs>
        <v-flex lg12 v-else-if="showMeta == false">
          <div style="float: left; width: 50%; margin-top: 10px;">
            <p>Please select a file to upload and click the "Upload" button to continue</p>
            <p class="smalltext">Maximum file size allowed: {{ objAuthorize.max_upload_size }}MB</p>
            <p class="smalltext">File types supported: {{ objAuthorize.allowed_file_types }}</p>
            <!--<v-checkbox class="normalCheckbox" v-if="attachmentCategories.length > 1" v-model="viewAllDocs" @change="fncViewAllDocuments()" label="View All Documents"></v-checkbox>-->
          </div>
          <div style="float: left; width: 50%;max-height:120px; margin-top: 10px;">
            <!--<div v-if="attachmentCategories.length > 1" >
              <p>Please select the attachment category</p>
              <v-select v-if="uploadError == false" :items="attachmentCategories" label="Attachment Category" @input="fncFilterAttachments()" class="dropdown" v-model="selectedAttachmentCategory" item-value="id" item-text="name" solo single-line></v-select>
              <v-select v-else :items="attachmentCategories" label="Attachment Category" @input="fncFilterAttachments()" class="dropdown" style="border: 1px solid red !important;" v-model="selectedAttachmentCategory" item-value="id" item-text="name" solo single-line></v-select>
              <small class="uploadError" v-if="uploadError == true">Please select a category, and then reupload the file.</small>
              <small>Please note changing the above status will filter the below list and categorize the below file</small>
            </div>
            <br />-->
            <input type="file" id="quoteFile" class="fileUpload" style="padding-top: 30px !important;padding-bottom: 30px !important;" @change="fncSetImageObj">
            <div class="fileHolder" style="height: 85px !important;">
              <p>Drag & Drop / Click to Add Files</p>
              <small>{{ fileName }}</small>
            </div>
<!--            <br />-->
<!--            <v-checkbox class="normalCheckbox" style="top: 40px !important;max-width:162px;display: block; float:right;" v-if="attachmentCategories.length > 1" v-model="viewAllDocs" @change="fncViewAllDocuments()" label="View All Documents"></v-checkbox>-->
          </div>
          <small style="margin-top: 20px;border-top: 1px solid #ECECEC;width: 100%; float: left;"  class="pt-4 pb-4" v-if="quoteSettings.attachments.length == 0 && busyUploading== 0"><strong>No attachments has been uploaded to this quote</strong></small>
          <p v-if="quoteSettings.attachments.length != 0 && busyUploading == 0">Filter attachment categories</p>
          <v-select style="width: 50% !important;" v-if="quoteSettings.attachments.length != 0 && busyUploading == 0" :items="attachmentCategories" label="Attachment Category" @input="fncFilterAttachments()" class="dropdown" v-model="selectedAttachmentCategory" item-value="id" item-text="name" solo single-line></v-select>
          <v-data-table :headers="headers" :items="filteredAttachments" v-if="quoteSettings.attachments.length != 0 && busyUploading== 0" class="elevation-1 attachmentList" hide-actions>
          <!--<v-data-table style="margin-top: 20px;float: left; clear: both;" :headers="headers" :items="quoteSettings.attachments" v-if="quoteSettings.attachments.length != 0" class="elevation-1" hide-actions>-->
            <template slot="items" slot-scope="props">
              <td width="25%"><a @click.prevent="fncOpenFile(props.item.path)">{{ props.item.original_filename }}</a></td>
              <td width="20%"><a @click.prevent="fncOpenFile(props.item.path)">{{ fncGetLocalizedDateFromUTC( props.item.created_timestamp ) }}</a></td>
              <td width="25%" v-if="attachmentCategories.length > 1"><v-select :items="attachmentCategories" label="Attachment Category" @input="fncSaveAttachmentCategory( props.item )" class="dropdown" v-model="props.item.category" item-value="id" item-text="name" solo single-line></v-select></td>
              <td width="25%" v-else class="text-xs-right">N/A</td>
              <td width="20%" v-html="fncFileOwner(props.item.fullname)"></td>
              <td width="10%"><a @click.prevent="fncRemoveImage(props.item.id)"><i class="material-icons">delete</i></a></td>
            </template>
          </v-data-table>
          <center v-if="busyUploading == 1" class="waitingUpload"><img width="200" src="../../shared/assets/images/3dloader.gif"  /></center>
          <!--<p v-if="busyUploading == 1" class="waitingUpload"><strong>Uploading... Please wait...</strong></p>-->
        </v-flex>
        <div class="pl-4 pr-4 pb-4 buttonHolder">
          <div style="float: right">
            <v-btn class="cancelButton" @click.stop="fncHideModal">Close</v-btn>
            <v-btn color="success" @click.stop="fncDeleteAttachments">Delete All Attachments</v-btn>
          </div>
        </div>
      </v-layout>
    </v-form>
  </v-container>
</template>

<script>
  import { mapGetters } from 'vuex';
  import DatePicker from 'vue2-datepicker'

  export default {
    name: 'Settings',
    data() {
      return {
        soId: null,
        tabkeys:['quote-attachments', 'purchase-order-attachments'],
        metaData: {
          name: '',
          surname: '',
          idNo: '',
          location: '',
          employer: '',
        },
        podCategory: this.$store.getters.podCategory,
        fileName: '',
        headers: [
          { text: 'File Name', value: 'name', width: '25%' },
          { text: 'Date Uploaded', value: 'name', width: '20%' },
          { text: 'Update Category', value: 'name', width: '25%' },
          { text: 'File Uploaded By', value: 'fullname', width: '20%' },
          { text: 'Delete', value: 'delete', width: '10%' },
        ],
        soHeaders: [
          { text: 'File Name', value: 'name', width: '25%' },
          { text: 'Date Uploaded', value: 'name', width: '15%' },
          { text: 'Category', value: 'name', width: '20%' },
          { text: '', value: 'button', width: '30%' },
          { text: 'Delete', value: 'delete', width: '5%' },
          { text: 'Is Paid', value: 'is_paid', width: '5%' }
        ],
        allowedFileTypes: [],
        maxFileSize: 5,
        selectedAttachmentCategory: '',
        filteredAttachments: [],
        viewAllDocs: true,
        uploadError: false,
        busyUploading: 0,
        showMeta: false,
        selectedIndex: 0
      };
    },
    methods: {
      fncCheckStatus(index) {
        var metaData = JSON.parse(this.quoteSettings.details.soAttachments[index].meta_data);

        if( metaData != null && metaData.status != undefined && this.quoteSettings.details.status !== 'POD Uploaded' ) {
          return false;
        }
        return true;
      },
      fncCheckPodStatus() {
        for( var s in this.soStatusList ) {
          if( this.soStatusList[s].is_pod_uploaded == 'Yes' ) {
            return 'Advance To ' + '"'+this.soStatusList[s].description+'"';
          }
        }
        return 'No Status Set';
      },
      fncUpdatePodStatus( itemId, index ) {

        if( this.quoteSettings.details.soAttachments[index].meta_data != null && this.quoteSettings.details.soAttachments[index].meta_data != undefined ) {
          var metaData = JSON.parse(this.quoteSettings.details.soAttachments[index].meta_data);
          metaData.status = true;
        } else {
          var metaData = [];
          metaData.status = true;
        }

        var stringMeta = JSON.stringify( metaData );

        this.quoteSettings.details.soAttachments[index].meta_data = stringMeta;

        var newStatus = [];
        for( var s in this.soStatusList ) {
          if( this.soStatusList[s].is_pod_uploaded == 'Yes' || this.soStatusList[s].is_pod_uploaded == '1' ) {
            newStatus = this.soStatusList[s];
          }
        }

        var podUpdate = {
          type: 'quote_status_change',
          prev_value: this.quoteSettings.details.status,
          new_value: newStatus.description,
          user: this.objAuthorize.id,
          target: this.globalModalParams.quoteId,
          data: 'Vendor: Updated from file upload screen',
          save: true,
          itemId: itemId
        }

        this.$store.dispatch('fncUpdatePodStatus', podUpdate);
        var oldThis = this;
        setTimeout(function(){

          oldThis.$store.dispatch({
            type: 'fncQuoteSettings',
            quoteId: oldThis.globalModalParams.quoteId,
            quoteNo: oldThis.quoteSettings.details.quote_no,
            data: oldThis.quoteSettings.details,
          })

        }, 500);
      },
      fncCancelMeta() {
        this.selectedIndex = "1"
        this.showMeta = false;
      },
      fncRemoveFile(key) {
        var doDelete = confirm('Are you sure you want to delete this file');
        if (doDelete == true) {
          this.$store.dispatch({
            type: 'fncRemoveSoAttachment',
            details: key,
            quoteNo: this.globalModalParams.quoteNo,
            isQuoteReport: 'yes',
          })
        }
      },
      getStyle(){
        if (this.quoteSettings.details.status !== 'POD Uploaded'){
          return 'width: 48%;'
        }
        else{
          return 'width: 78%;'
        }
      },
      fncShowMeta(id, meta) {
        this.showMeta = true;
        this.soId = id
        if (meta != null)
        {
         // console.log(typeof meta)
          meta = JSON.parse(meta)
          this.metaData = { name: meta.name,  surname: meta.surname,  idNo: meta.idNo,  location: meta.loading,  employer: meta.employer }
        }
        else{
          this.metaData = { name: '',  surname: '',  idNo: '',  location: '',  employer: '' }
        }
        // this.$store.commit('setGlobalModalTitle', 'Delivery Note' + ' - ' + this.globalModalParams.fullQuote.quoteNo);
      },
      fncSaveMeta() {
        var vendorId = 0;
        if( this.globalModalParams.vendor != undefined && this.globalModalParams.vendor != 'undefined' ) {
          vendorId = this.globalModalParams.vendor;
        }
        this.$store.dispatch({
          type: 'fncUpdateSoMeta',
          metaData: this.metaData,
          vendor: vendorId,
          quote: this.globalModalParams.quoteId,
          soId: this.soId
        })
        var oldThis = this;
        setTimeout(function(){
          oldThis.showMeta = false;
          oldThis.selectedIndex = "1"

          oldThis.$store.dispatch({
            type: 'fncQuoteSettings',
            quoteId: oldThis.globalModalParams.quoteId,
            quoteNo: oldThis.quoteSettings.details.quote_no,
            data: oldThis.quoteSettings.details,
          })

        }, 500);
        // this.$store.commit('setGlobalModalTitle', 'Purchase Order Attachments' + ' - ' + this.globalModalParams.fullQuote.quoteNo);

      },
      fncCanUpdatePod( item ) {
        var hasStatus = false;
        for( var s in this.soStatusList ) {
          if( this.soStatusList[s].is_pod_uploaded == 'Yes' || this.soStatusList[s].is_pod_uploaded == '1' ) {
            hasStatus = true;
          }
        }

        if( hasStatus == true ) {
          if( item.category != this.podCategory ) {
             hasStatus = false;
          }
        }

        // else if ( item.category == this.podCategory ){
        //   hasStatus = true
        // }

        return hasStatus;
      },
      fncDeleteAttachments() {

        var confirmDelete = confirm("Are you sure you want to remove All attachments?");

        if( confirmDelete ) {
          this.quoteSettings.details.soAttachments = [];
          this.quoteSettings.attachments = [];
          this.$store.dispatch('fncDeleteAllAttachments', this.globalModalParams.quoteId)
        }

      },
      fncFileOwner( fullname ) {
        if( fullname == '' || fullname == 'null' || fullname == null ) {
          return 'N/A';
        } else {
          return fullname;
        }
      },
      fncGetLocalizedDateFromUTC ( theDate ) {

        var options = {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
          hour: "numeric",
          minute: "numeric",
          hour12: false
        };

        var newDate = new Date( Date.parse(theDate + ' UTC') );
        var dateString = newDate.toLocaleString("en", options);
        var objDate = dateString.split(',');

        var newDate = objDate[0].split('/');

        var strDate = newDate[2] + '-' + newDate[0] + '-' + newDate[1] + ' ' + objDate[1];

        return strDate;

      },
      fncSaveAttachmentCategory( attachment ) {
        this.$store.dispatch({
          type: 'fncUpdateAttachmentCategory',
          attachmentId: attachment,
          quoteId: this.globalModalParams.quoteId
        });
      },
      fncViewAllDocuments() {
        if( this.viewAllDocs == false ) {
          if( this.attachmentCategories.length > 0  && ( this.selectedAttachmentCategory == 0 || this.selectedAttachmentCategory == '' ) ) {
            this.selectedAttachmentCategory = this.attachmentCategories[0].id;
          }
        } else {
          this.filteredAttachments = this.quoteSettings.attachments;
          this.selectedAttachmentCategory = '';
        }
      },
      fncFilterAttachments() {
        this.viewAllDocs = false;
        this.filteredAttachments = [];

        if( this.selectedAttachmentCategory == 0 ) {
          for( var c in this.quoteSettings.attachments ) {
            if( this.quoteSettings.attachments[c].category == null || this.quoteSettings.attachments[c].category == 'null' || this.quoteSettings.attachments[c].category == 0 ) {
              this.filteredAttachments.push(this.quoteSettings.attachments[c]);
            }
          }
        } else {
          for( var c in this.quoteSettings.attachments ) {
            if( this.selectedAttachmentCategory != 0 && ( this.quoteSettings.attachments[c].category == this.selectedAttachmentCategory ) ) {
              this.filteredAttachments.push(this.quoteSettings.attachments[c]);
            }
          }
        }
      },
      fncOpenFile(fileUrl) {
        if( !fileUrl.includes('https') ) {
          window.open(window.location.origin+'/attachments/'+fileUrl, '_blank');
        } else {
          window.open(fileUrl, '_blank');
        }
      },
      fncHideModal() {
        if( window.location.hash.indexOf('quote-reports-lite') != -1 || window.location.hash.indexOf('quote-single-content?quote=') != -1 ) {
          window.location.reload();
        } else {
          this.$store.commit('hideModal');
        }
      },
      fncChangeUserType() {
        var companyType = this.userType == 2 ? 1 : 2;
        this.$store.dispatch({
          type: 'fncResetSetupUserCreate',
          companyType: companyType,
          userType: this.userType
        });
      },
      fncUpdateQuoteSettings() {
        this.$store.dispatch('fncUpdateQuoteSettings')
      },
      fncMarkPaid(item){
        const isChecked = (item.is_paid) ? 1 : 0;
        const id = item.id;
        this.$store.dispatch({
          type: 'fncMarkPaid',
          attachmentId: id,
          is_paid: isChecked,
          quoteId: this.globalModalParams.quoteId,
          isQuoteReport: true
        })
      },
      fncRemoveImage(key) {
        var doDelete = confirm('Are you sure you want to delete this file/image');
        if (doDelete == true) {
          this.$store.dispatch({
            type: 'fncRemoveQuoteAttachment',
            attachmentId: key,
            quoteId: this.globalModalParams.quoteId
          })
        }
      },
      fncSetSoImageObj(e) {
        var files = e.target.files[0] || e.dataTransfer.files[0];
        var vm = this;
        var fivemeg = 5 * 1000000;
        if (parseInt(files.size) > fivemeg) {
          var snackDetails = { color: 'error', message: 'Please upload a file smaller than 5MB', display: true };
          this.$store.commit('setSnack', snackDetails);
        } else {
          var fileObj = String(files.name).split('.');
          var fileType = '.'+fileObj[fileObj.length-1];
          fileType = fileType.toLowerCase();
          if ( this.allowedFileTypes.indexOf( fileType ) != -1 ) {
            //if (files.type == 'application/pdf' || files.type === 'image/png' || files.type === 'image/jpg' || files.type === 'image/jpeg' || files.type == 'application/pdf' || files.type == 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' || files.type == 'application/vnd.ms-excel' || files.type == 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' || files.type == 'application/msword' || files.type == 'application/x-zip-compressed' || files.type == 'text/plain') {
            this.fileObj = files;
            var currentInput = document.getElementById('quoteFile');
            currentInput.value = '';
            let soId = 0
            let vendor = 0
            if (
              this.quoteSettings &&
              this.quoteSettings.details &&
              this.quoteSettings.details.soAttachments &&
              this.quoteSettings.details.soAttachments.length > 0
            ) {
              soId = this.quoteSettings.details.soAttachments[0].sales_order_id;
              vendor = this.quoteSettings.details.soAttachments[0].vendor;
            }
            this.$store.dispatch({
              type: 'fncUploadSoImage',
              files: files,
              quoteId: this.globalModalParams.quoteId,
              quoteNo: this.quoteSettings.details.quote_no,
              vendorId: this.globalModalParams.vendor,
              fullQuote: this.quoteSettings.details,
              soId: (soId == undefined || soId == 'undefined') ? 0 : soId,
              vendor_second: vendor,
              isQuoteReport: 'yes',
              category: this.podCategory
            })
          } else {
            var snackDetails = { color: 'error', message: 'Please upload a valid file type', display: true };
            this.$store.commit('setSnack', snackDetails);
          }
        }
      },
      fncSetImageObj(e) {
        /* if( this.selectedAttachmentCategory == '' && this.attachmentCategories.length > 1 ) {
          document.getElementById("quoteFile").value = "";
          this.uploadError = true;
          this.busyUploading = 0;
        } else { */
          this.selectedAttachmentCategory = 0;
          this.uploadError = false;
          var files = e.target.files[0] || e.dataTransfer.files[0];
          if( this.maxFileSize != '' || this.maxFileSize != 0 ) {
            var fivemeg = parseInt(this.maxFileSize) * 1000000;
          } else {
            var fivemeg = 5 * 1000000;
          }
          if (parseInt(files.size) > fivemeg) {
            var snackDetails = { color: 'error', message: 'Please upload a file smaller than 5MB', display: true };
            this.$store.commit('setSnack', snackDetails);
            this.busyUploading = 0;
          } else {
            var vm = this;
            var fileObj = String(files.name).split('.');
            var fileType = '.'+fileObj[fileObj.length-1];
            fileType = fileType.toLowerCase();
            if ( this.allowedFileTypes.indexOf( fileType ) != -1 ) {
              this.fileObj = files;
              var currentInput = document.getElementById('quoteFile');
              currentInput.value = '';
              this.$store.dispatch({
                type: 'fncUploadQuoteImage',
                files: files,
                quoteId: this.globalModalParams.quoteId,
                attachmentCategory: this.selectedAttachmentCategory
              })
              this.busyUploading = 1;
            } else {
              var snackDetails = { color: 'error', message: 'Please upload a valid file type', display: true };
              this.$store.commit('setSnack', snackDetails);
              this.busyUploading = 0;
            }
          }
        // }
      }
    },
    components: {
      DatePicker
    },
    computed: {
      ...mapGetters([
        'objAuthorize',
        'globalModalParams',
        'quoteSettings',
        'attachmentCategories',
        'soStatusList',
      ])
    },
    created() {
      this.$store.dispatch('fncPopulateRegionList');
      this.allowedFileTypes = String(this.objAuthorize.allowed_file_types).split(',');
      this.maxFileSize = parseInt(this.objAuthorize.max_upload_size);
      this.viewAllDocs = true;
    },
    beforeMount() {
      this.$store.commit('fncEmptyAttachmentCategories');
      this.$store.dispatch('fncGetAttachmentCategories');
      this.viewAllDocs = true;

      if (this.quoteSettings && this.quoteSettings.details && this.quoteSettings.details.soAttachments &&
        this.quoteSettings.details.soAttachments.length > 0
      ) {
        this.metaData = JSON.parse(this.quoteSettings.details.soAttachments[0].meta_data);
      }

      if( this.metaData == null || this.metaData == 'null' ) {
        this.metaData = { name: '',  surname: '',  idNo: '',  location: '',  employer: '' };
      }
    },
    mounted() {
      this.viewAllDocs = true;
    },
    watch: {
      filteredAttachments() {
        this.busyUploading = 0;
      },
      quoteSettings() {
        if( this.attachmentCategories.length > 1 ) {
          if( this.viewAllDocs == true ) {
            this.filteredAttachments = this.quoteSettings.attachments;
          } else {
            this.filteredAttachments = [];
            for( var c in this.quoteSettings.attachments ) {
              if( this.selectedAttachmentCategory != 0 && ( this.quoteSettings.attachments[c].category == this.selectedAttachmentCategory ) ) {
                this.filteredAttachments.push(this.quoteSettings.attachments[c]);
              }
            }
          }
        } else {
          this.filteredAttachments = this.quoteSettings.attachments;
        }
      },
      attachmentCategories() {
        this.filteredAttachments = this.quoteSettings.attachments;
        /*if( this.attachmentCategories.length > 0  && ( this.selectedAttachmentCategory == 0 || this.selectedAttachmentCategory == '' ) ) {
          this.selectedAttachmentCategory = this.attachmentCategories[0].id;
        }*/
      },
      selectedAttachmentCategory() {
        if( this.viewAllDocs != true ) {
          this.filteredAttachments = [];

          if( this.selectedAttachmentCategory == 0 ) {
            for( var c in this.quoteSettings.attachments ) {
              if( this.quoteSettings.attachments[c].category == null || this.quoteSettings.attachments[c].category == 'null' || this.quoteSettings.attachments[c].category == 0 ) {
                this.filteredAttachments.push(this.quoteSettings.attachments[c]);
              }
            }
          } else {
            for( var c in this.quoteSettings.attachments ) {
              if( this.selectedAttachmentCategory != 0 && ( this.quoteSettings.attachments[c].category == this.selectedAttachmentCategory ) ) {
                this.filteredAttachments.push(this.quoteSettings.attachments[c]);
              }
            }
          }
        }
      }
    }
  }
</script>

<style scoped>
  /*@import '../../assets/css/shared.css'*/
  tr{
    vertical-align: initial;
  }

  td div {
    font-size: 12px !important;
  }
  .table__overflow {
    overflow:hidden;
    overflow-y: scroll;
    height: 500px;
  }
  .thead.fixed {
    top: 0;
    z-index: 2;
    position: sticky;
    background-color: white;
  }
</style>
